export const SESSION_EXPIRED_RESPONSE = Object.freeze({ sessionExpired: true });

let sessionExpiredHandler = null;
let isSessionExpiredDialogOpen = false;

export class SessionExpiredError extends Error {
  constructor() {
    super('Session expired');
    this.name = 'SessionExpiredError';
    this.isSessionExpired = true;
  }
}

export function isSessionExpiredError(error) {
  return error instanceof SessionExpiredError || error?.isSessionExpired === true;
}

export function isSessionExpiredResponse(response) {
  return response?.sessionExpired === true;
}

export function setSessionExpiredHandler(handler) {
  sessionExpiredHandler = handler;
}

export function notifySessionExpired() {
  if (isSessionExpiredDialogOpen) {
    return;
  }

  isSessionExpiredDialogOpen = true;
  sessionExpiredHandler?.();
}

export function resetSessionExpiredDialogState() {
  isSessionExpiredDialogOpen = false;
}
